import React from 'react'
import { Helmet } from 'react-helmet'

const CustomizedHelmet = ({ title = '' }) => {
  return (
    <Helmet>
      <meta charSet={'utf-8'} />
      <meta http-equiv={'Content-Type'} content={'text/html; charset=UTF-8'} />
      <meta
        name={'description'}
        content={
          'Alla digitala behov för din bostads- eller hyresrättsförening samlad i en app. Boka tvättid i er tvättstuga via HomePal.'
        }
      />
      <meta name={'viewport'} content={'width=device-width, initial-scale=1'} />
      <title>{title}</title>
    </Helmet>
  )
}

export { CustomizedHelmet }



// WEBPACK FOOTER //
// ./src/components/common/CustomizedHelmet.js